module.exports = __webpack_public_path__ + "img/54.e675b6c6.jpg";